// eslint-disable-next-line no-restricted-imports
import {
  Query_LegalClientController_GetById_FinancialMonitoring_FinanceInfo_AmlPolicyReviewFrequency as AmlPolicyReviewFrequencyApi,
  Query_LegalClientController_GetById_FinancialMonitoring_FinanceInfo_MonetaryServiceTransactionCountForLastSixMonths as MonetaryServiceTransactionCountForLastSixMonthsApi,
  FinancialMonitoringDto_Input,
} from 'api/generated/graphql';
import { LegalClientFinancialMonitoringEntity } from 'api/types/entity';
import { formatToISODate } from 'helpers';

export const parseFinancialMonitoringParams = (
  params: LegalClientFinancialMonitoringEntity
): FinancialMonitoringDto_Input => ({
  isSubjectToRegulation: params.isSubjectToRegulation,
  financeInfo: params.financeInfo
    ? {
        ...params.financeInfo,
        amlPolicyReviewFrequency:
          AmlPolicyReviewFrequencyApi[
            params.financeInfo.amlPolicyReviewFrequency
          ],
        monetaryServiceTransactionCountForLastSixMonths:
          MonetaryServiceTransactionCountForLastSixMonthsApi[
            params.financeInfo.monetaryServiceTransactionCountForLastSixMonths
          ],
        dateOfLastCheck: params.financeInfo.dateOfLastCheck
          ? formatToISODate(params.financeInfo.dateOfLastCheck)
          : undefined,
      }
    : undefined,
});
